import React from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar'; 

const galleryImages = [
  '/gallery/16.JPG',
  '/gallery/2.JPG',
  '/gallery/3.JPG',
  '/gallery/4.JPG',
  '/gallery/20.JPG',
  '/gallery/22.JPG',
  '/gallery/7.JPG',
  '/gallery/8.JPG',
  '/gallery/1.JPG',
  '/gallery/24.JPG',
  '/gallery/25.JPG',
  '/gallery/26.JPG'
];

const GallerySection = () => {
  return (
    <>
      {/* ✅ Top Navbar */}
      <Navbar />

      {/* Gallery Section */}
      <section className="bg-gray-100 py-16">
        <div className="max-w-screen-xl mx-auto px-4">
         <h2 className="text-3xl font-bold text-blue-900 mb-8 text-center">Gallery</h2>


          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {galleryImages.map((img, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
                viewport={{ once: true }}
                className="overflow-hidden rounded-lg shadow-md"
              >
                <img
                  src={img}
                  alt={`Gallery ${index + 1}`}
                  className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default GallerySection;
